import { genericRequest, processedSectionsRoute } from "./service"

/**
 * Fetches the processed section data for a given section ID.
 * 
 * @param sectionId to fetch processed section data for
 * 
 * @returns processed section data
 */
export const getProcessedSectionData = async (sectionId: number) => {
  return genericRequest({url: `${processedSectionsRoute}/${sectionId}/processed-section`, method: "GET" })
}
/**
 * Gets the processed THz heatmap image for a section.
 * 
 * @param sectionId of section to fetched THz heatmap image for
 * 
 * @returns processed THz heatmap of the given section
 */
export const getProcessedTHzHeatmapImage = async (sectionId: number) => {
  return genericRequest({ 
    url: `${processedSectionsRoute}/${sectionId}/thz-heatmap-image`,
    method: "GET",
    raw: true
  })
}

/**
 * Gets the processed IR heatmap image for a section.
 * 
 * @param sectionId of section to fetched ifrared heatmap image for
 * 
 * @returns processed inrared heatmap of the given section
 */
export const getProcessedIRHeatmapImage = async (sectionId: number) => {
  return genericRequest({ 
    url: `${processedSectionsRoute}/${sectionId}/ir-heatmap-image`,
    method: "GET",
    raw: true
  })
}

/**
 * Gets the processed metal heatmap image for a section.
 * 
 * @param sectionId of section to fetched metal heatmap image for
 * 
 * @returns processed metal heatmap of the given section
 */
export const getProcessedMetalHeatmapImage = async (sectionId: number) => {
  return genericRequest({ 
    url: `${processedSectionsRoute}/${sectionId}/metal-heatmap-image`,
    method: "GET",
    raw: true
  })
}

/**
 * Gets the processed heatmap image mask for a section.
 * 
 * @param sectionId of section to fetched heatmap image mask for
 * 
 * @returns processed heatmap image mask of the given section
 */
export const getProcessedHeatmapImageMask = async (sectionId: number) => {
  return genericRequest({ 
    url: `${processedSectionsRoute}/${sectionId}/heatmap-image-mask`,
    method: "GET",
    raw: true
  })
}
